export default __webpack_public_path__ + "static/media/hand-holding-bag-of-money.864b9eb4.svg";